<template>
  <div>
    <div class="page-content">
      <div class="container-fluid background">
        <div class="row">
          <img src="~@/assets/images/sunset.jpg" alt="Sunset" class="col-12 p-0">
        </div>
      </div>
      <div class="container content">
        <div class="row">

          <div class="col-12">
            <h1 class="page-header">
              Contact Details
              <hr />
            </h1>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="phone-email col-12">
                <p>
                  <strong>Tel</strong>:
                  <a href="tel:07759208525">07759 208525</a>
                </p>
                <hr>
                <p>
                  <strong>Email</strong>:
                  <a href="mailto:here4yousbsn@gmail.com">
                    here4yousbsn@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'contact-us'
}
</script>

<style lang="scss">
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";
/****************************
    BANNER
*****************************/
.background {
  margin-top: -64px;
  width: 100%;
  height: 430px;
  border-bottom: 3px solid $primary;

  @media screen and (max-width: $md-breakpoint) {
    height: 300px;
  }

  .row {
    height: 100%;
  }

  .row img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

/****************************
    FORM
*****************************/
.content {
  margin-top: 64px;
}

.page-content {
  border-bottom: 3px $primary solid;
}

label {
  font-weight: 600;
}

.errors,
.success {
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 30px;
}

.success {
  color: #1c723d;
  background-color: #d7f8e5;
  border-color: #c6f5d6;
}

.errors {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}

.required {
  &::after {
    content: "*";
    color: #ce1426;
  }
}

.phone-email,
.address {
  display: flex;
  flex-direction: column;
  justify-content: center;
  p {
    margin: 0;
  }
  hr {
    margin: 10px 0;
  }
}

textarea {
  min-height: 135px;
}

input,
textarea {
  &:not([type="checkbox"]) {
    &:focus {
      border-color: $primary;
      outline: 0;
      -webkit-box-shadow: 0 0 0 0.2rem rgba(57, 173, 121, 0.25);
      box-shadow: 0 0 0 0.2rem rgba(57, 173, 121, 0.25);
    }
  }
}

#chckbox-label {
  display: flex;
  gap: 15px;
  cursor: pointer;
}

input[type="checkbox"] {
  cursor: pointer;
  /* Add if not using autoprefixer */
  -webkit-appearance: none;
  /* Remove most all native input styles */
  appearance: none;
  /* For iOS < 15 */
  background-color: var(--form-background);
  /* Not removed via appearance */
  margin: 0;

  font: inherit;
  color: currentColor;
  min-width: 24px;
  width: 24px;
  height: 24px;
  border: 1px solid #ced4da;
  border-radius: 2.4px;
  transform: translateY(-1.2px);

  display: grid;
  place-content: center;
}

input[type="checkbox"]::before {
  content: "";
  width: 12px;
  height: 12px;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  transform: scale(0);
  transform-origin: bottom left;
  transition: 120ms transform ease-in-out;
  box-shadow: inset 16px 16px var(--form-control-color);
  /* Windows High Contrast Mode */
  background-color: $white;
}

input[type="checkbox"]:checked {
  background-color: $primary;
}

input[type="checkbox"]:checked::before {
  transform: scale(1);
}

input[type="checkbox"]:focus {
  outline: none;
  outline-offset: 0;
}

input[type="checkbox"]:disabled {
  --form-control-color: var(--form-control-disabled);

  color: var(--form-control-disabled);
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/ContactUs.vue